var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThingsToDo",
    transform: "translate(-1253.000000, -62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(851.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.000000, 19.000000)",
    id: "Icons/Angle-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333333,3.33333333 L15,3.33333333 L15,1.66666667 L13.3333333,1.66666667 L13.3333333,3.33333333 L6.66666667,3.33333333 L6.66666667,1.66666667 L5,1.66666667 L5,3.33333333 L4.16666667,3.33333333 C3.24166667,3.33333333 2.50833333,4.08333333 2.50833333,5 L2.5,16.6666667 C2.5,17.5833333 3.24166667,18.3333333 4.16666667,18.3333333 L15.8333333,18.3333333 C16.75,18.3333333 17.5,17.5833333 17.5,16.6666667 L17.5,5 C17.5,4.08333333 16.75,3.33333333 15.8333333,3.33333333 L15.8333333,3.33333333 Z M15.8333333,16.6666667 L4.16666667,16.6666667 L4.16666667,7.5 L15.8333333,7.5 L15.8333333,16.6666667 L15.8333333,16.6666667 Z",
    id: "Icon",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#ADB5BD",
    points: "5.83333333 9.16666667 10 9.16666667 10 13.3333333 5.83333333 13.3333333"
  })))))));
};
export default SvgCalendar;